import lodashDeburr from 'lodash/fp/deburr';

export default function slugify(string) {
  if (!string) {
    return '';
  }
  return lodashDeburr(string)
    .trim()
    .replace(/ /g, '-')
    .replace(/\./g, '')
    .replace(/&/g, 'and')
    .replace(/\//g, '-') // Replace slashes with hyphens
    .replace(/,/g, '') // Remove commas
    .replace(/'/g, '') // Remove apostrophes
    .toLowerCase();
}
